<!-- <footer id="aha-footer" class="l-footer pmp-footer"></footer> -->


<footer id="aha-footer" class="l-footer pmp-footer">
    Built by The <a target="_blank" href="https://heart.org">American Heart Association</a>. Used by researchers across
    industries.
</footer>
<button id="ot-sdk-btn" class="d-flex w-100 justify-content-center btn ot-sdk-show-settings">Cookies Settings</button>
